import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { HeaderButtonRow } from "../../../partial-templates/header-button-row/header-button-row.stories";
import { DetailHeader } from "../../../partial-templates/detail-header/detail-header.stories";
import { tabLicences } from "./tabs/licences";
import { tabDownloads } from "./tabs/downloads";
import { tabDownloadsNoServiceAgreements } from "./tabs/downloads-no-service-agreement";
import { renderPageTemplate } from "../../../../utils";

export default {
    title: "MyTrumpf/Page Templates/My Software/Detail",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        serviceAgreements: true,
    },
    argTypes: {
        serviceAgreements: {
            control: { type: "boolean" },
        },
    },
};

const Template = (args) => {
    return html` <div class="ux-t-container">
        <div class="ux-row ux-u-mt-l" data-software-id="1">
            <div class="ux-col-12">
                ${HeaderButtonRow({
                    buttons:
                        "<ux-toggle-button class='ux-button' icon-on='fav-filled' icon-off='fav' label-off='Favorisieren' label-on='Favorit' label-visibility='m' off></ux-toggle-button>",
                })}
                ${DetailHeader({
                    image: true,
                    headline: "User machine name",
                    keyValuePairs: [
                        {
                            title: "Latest delivered version",
                            value: "11.12.0",
                        },
                        {
                            title: "Latest available version",
                            value: "13.16.22",
                            detail: "Released on 25.02.22",
                        },
                        {
                            title: "Service Agreement Status",
                            value: "Active",
                            status: "active",
                        },
                        {
                            title: "Contract Start",
                            value: "17.01.2022",
                        },
                        { title: "Number of licenses", value: "3" },
                    ],
                })}
            </div>
            <div class="ux-col-12 ux-u-mt-l">
                <ux-tab-container fix-to-top scroll-when-activated>
                    <ux-tab
                        name="Licenses"
                        tab-id="licenses-content"
                        class="ux-u-mt-xxs ux-u-mt-lg-xs ux-u-mb-s"
                    >
                        ${tabLicences()}
                    </ux-tab>
                    <ux-tab
                        name="Downloads"
                        tab-id="downloads-content"
                        class="ux-u-mt-xxs ux-u-mt-lg-s ux-u-mb-s"
                    >
                        ${args.serviceAgreements
                            ? tabDownloads()
                            : tabDownloadsNoServiceAgreements()}
                    </ux-tab>
                </ux-tab-container>
            </div>
        </div>
    </div>`;
};

export const Default = (args) =>
    renderPageTemplate(() => Template({ ...args }));
